import { render, staticRenderFns } from "./Archiveren.vue?vue&type=template&id=ef6da1b6"
import script from "./Archiveren.vue?vue&type=script&lang=js"
export * from "./Archiveren.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports